<template>
  <div name="stdapplinf-detail-pg14">
    <hrms-table :columns="columns" :data="data" />
    <div class="row">
      <div class="col-md-3 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['30'] }}</label>
          <div class="form-control readonly-field-color">{{ setDateOutput(dteupd) }}</div>
        </div>
      </div>
      <div class="col-md-3 col-md-offset-1">
        <div class="form-group">
          <label>{{ labels['40'] }}</label>
          <div class="form-control readonly-field-color">{{ coduser }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'stdapplinf-detail-pg14',
  computed: {
    dteupd () {
      let dteupd = ''
      if (this.data.rows.length > 0) {
        dteupd = this.data.rows.map((row) => {
          return row.dteupd
        }).pop()
      }
      return dteupd
    },
    coduser () {
      let coduser = ''
      if (this.data.rows.length > 0) {
        coduser = this.data.rows.map((row) => {
          return row.coduser
        }).pop()
      }
      return coduser
    }
  },
  props: [ 'labels', 'data', 'columns' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg14.vue?2725767c